import React, { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';
import '../scss/achievementModal.scss';

const AchievementModal = ({ achievement, onClose, isLocked = false }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Short delay before showing content and firing confetti
        const timer = setTimeout(() => {
            setIsVisible(true);
            
            // Only create confetti effect for achieved achievements
            if (!isLocked) {
                // Create confetti effect
                const count = 200;
                const defaults = {
                    origin: { y: 0.7 },
                    zIndex: 1500
                };

                function fire(particleRatio, opts) {
                    confetti({
                        ...defaults,
                        ...opts,
                        particleCount: Math.floor(count * particleRatio),
                        scalar: 1.2,
                        shapes: ['star', 'circle'],
                        colors: ['#ffd700', '#ffa500', '#ffffff', '#ff6b6b'],
                        ticks: 200,
                        gravity: 1.2,
                        decay: 0.94,
                        startVelocity: 30,
                        spread: 70,
                    });
                }

                // Launch initial burst
                fire(0.25, {
                    spread: 26,
                    startVelocity: 55,
                });
                fire(0.2, {
                    spread: 60,
                });
                fire(0.35, {
                    spread: 100,
                    decay: 0.91,
                    scalar: 0.8
                });
                fire(0.1, {
                    spread: 120,
                    startVelocity: 25,
                    decay: 0.92,
                    scalar: 1.2
                });
                fire(0.1, {
                    spread: 120,
                    startVelocity: 45,
                });
            }
        }, 100); // Short delay for mounting

        return () => {
            clearTimeout(timer);
            if (!isLocked) {
                confetti.reset();
            }
        };
    }, [isLocked]);

    const handleBackgroundClick = (e) => {
        // Only close if clicking the background overlay
        if (e.target.className.includes('achievement-modal')) {
            onClose();
        }
    };

    // Format the achievement date for display
    const formatAchievementDate = (dateString) => {
        if (!dateString) return null;
        
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
        } catch (error) {
            console.error('Error formatting date:', error);
            return null;
        }
    };

    return (
        <div 
            className={`achievement-modal ${isVisible ? 'visible' : ''} ${isLocked ? 'locked' : ''}`}
            onClick={handleBackgroundClick}
        >
            <div className={`achievement-content ${isVisible ? 'visible' : ''} ${isLocked ? 'locked' : ''}`}>
                <div className="achievement-icon">
                    {achievement.icon}
                </div>
                <h2>{isLocked ? 'Achievement Locked' : 'Achievement Unlocked!'}</h2>
                <h3>{achievement.title}</h3>
                <p>{achievement.description}</p>
                {!isLocked && achievement.achievedDate && (
                    <div className="achievement-date">
                        Achieved on {formatAchievementDate(achievement.achievedDate)}
                    </div>
                )}
                <button onClick={onClose}>{isLocked ? 'Close' : 'Continue'}</button>
            </div>
        </div>
    );
};

export default AchievementModal; 